const requireRouter = require.context('.', false, /^(?!\.\/index|\.\/cockpit).*\.js$/)
let routers = []

requireRouter.keys().forEach(fileName => {
  routers = [...routers, ...requireRouter(fileName).default]
})

export default routers



// WEBPACK FOOTER //
// ./src/router/client/index.js